// src/pages/TestCheckSubscriptionPage.jsx
import React, { useState, useEffect } from 'react';
import { useSocket } from '../../../../context/SocketContext';

export default function TestCheckSubscriptionPage() {
  const socket = useSocket();
  const [receiptId, setReceiptId] = useState('');
  const [logs, setLogs] = useState([]);

  const addLog = (msg) => {
    setLogs(prev => [...prev, `${new Date().toLocaleTimeString()}: ${msg}`]);
  };

  // Log socket lifecycle
  useEffect(() => {
    addLog(`useEffect socket changed: socket is ${socket ? 'present' : 'undefined'}`);
    if (!socket) return;

    addLog(`socket.connected = ${socket.connected}`);
    const onConnect = () => addLog('Socket.IO: connected');
    const onDisconnect = (reason) => addLog(`Socket.IO: disconnected (${reason})`);
    const onReconnect = (attempt) => addLog(`Socket.IO: reconnect attempt ${attempt}`);

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('reconnect_attempt', onReconnect);

    return () => {
      addLog('Cleaning up socket lifecycle handlers');
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('reconnect_attempt', onReconnect);
    };
  }, [socket]);

  // Subscribe action
  const subscribe = () => {
    addLog(`subscribe() called with receiptId='${receiptId}'`);
    if (!socket) {
      addLog('Error: no socket instance');
      return;
    }
    addLog('Emitting check:subscribe');
    socket.emit('check:subscribe', { receiptId }, (err) => {
      if (err) {
        addLog(`check:subscribe ack error: ${err}`);
      } else {
        addLog(`check:subscribe ack success: subscribed to receipt ${receiptId}`);
      }
    });
  };

  // Unsubscribe action
  const unsubscribe = () => {
    addLog(`unsubscribe() called with receiptId='${receiptId}'`);
    if (!socket) {
      addLog('Error: no socket instance');
      return;
    }
    addLog('Emitting check:unsubscribe');
    socket.emit('check:unsubscribe', { receiptId }, (err) => {
      if (err) {
        addLog(`check:unsubscribe ack error: ${err}`);
      } else {
        addLog(`check:unsubscribe ack success: unsubscribed from receipt ${receiptId}`);
      }
    });
  };

  // Handler for incoming updates
  useEffect(() => {
    if (!socket) return;
    const handler = (data) => {
      addLog(`Received check:update event: ${JSON.stringify(data)}`);
    };
    addLog('Setting up listener for check:update');
    socket.on('check:update', handler);
    return () => {
      addLog('Removing listener for check:update');
      socket.off('check:update', handler);
    };
  }, [socket]);

  return (
    <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
      <h1>Test Check Subscription</h1>
      <div>
        <label>
          Receipt ID:{' '}
          <input
            type="text"
            value={receiptId}
            onChange={e => setReceiptId(e.target.value)}
            placeholder="Enter receiptId"
            style={{ marginRight: 8 }}
          />
        </label>
        <button onClick={subscribe} style={{ marginRight: 8 }}>Subscribe</button>
        <button onClick={unsubscribe}>Unsubscribe</button>
      </div>
      <div style={{ marginTop: 20 }}>
        <h2>Logs</h2>
        <div style={{ background: '#eee', padding: 10, height: '300px', overflowY: 'auto' }}>
          {logs.map((log, i) => <div key={i}>{log}</div>)}
        </div>
      </div>
    </div>
  );
}